/**
 * Lista de referencia para valores de los estados de la hoja de vida
 * 
 */
export const TipoEstadoHv = [
    { code: 'NO_TIENE_HV', value: 'No tiene CV' },
    { code: 'TIENE_HV', value: 'Tiene CV' },
    { code: 'HV_TERMINADA', value: 'CV terminado' },
];